<template>
  <Modal
    v-model:open="innerVisible"
    title="日志"
    width="1016px"
    @cancel="innerVisible = false"
    @ok="handleOk"
  >
    <BaseTable
      :columns="columns"
      :is-loading="isLoading"
      :pagination="pagination"
      :table-data="tableData"
      table-height="45vh"
      @change-page="onChangePage"
    />
  </Modal>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref, defineProps, defineEmits } from 'vue'
import { type TableColumnsType } from 'ant-design-vue'
import { type Pagination, type LogDataListItem } from '../types'
import { getLog } from '../service'
import BaseTable from './base-table/index.vue'
import dayjs from 'dayjs'
import { Modal } from 'ant-design-vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  id: {
    type: Number,
    default: 0,
  },
  itemText: {
    type: String,
    default: '',
  },
})

const emits = defineEmits(['update:visible', 'submit'])
const innerVisible = computed({
  get() {
    return props.visible
  },
  set(val) {
    emits('update:visible', val)
  },
})

const isLoading = ref<boolean>(false)
const tableData = ref<LogDataListItem[]>()
const pagination = reactive<Pagination>({
  pageSize: 100,
  page: 1,
  total: 0,
})

const getList = () => {
  isLoading.value = true

  getLog(
    props.id,
    pagination.page,
    pagination.pageSize,
  )
    .then(res => {
      const list = res.list || []

      list.forEach(i => {
        i.operateTimeFE = dayjs(+i.operateTime * 1000).format('YYYY-MM-DD HH:mm:ss')
      })

      tableData.value = list
      pagination.total = +res.total
    })
    .finally(() => {
      isLoading.value = false
    })
}

const onChangePage = (page: number) => {
  pagination.page = page
  getList()
}

onMounted(() => {
  getList()
})

const handleOk = () => {
  innerVisible.value = false
}

const columns = ref<TableColumnsType>([
  {
    title: '操作人',
    dataIndex: 'operateUser',
    resizable: true,
    width: 100,
  },
  {
    title: '操作时间',
    dataIndex: 'operateTimeFE',
    resizable: true,
    width: 100,
  },
])
</script>
